// extracted by mini-css-extract-plugin
module.exports = {"root":"DeliveryAddress_root__1eboj","deliveryType":"DeliveryAddress_deliveryType__3Nkgx"};